import { useMemo } from 'react';
import { LorawanActionTypes } from '@utils/deviceActions';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import { DeviceLoraWanProps } from '@pages/LoraWan/types';
import rolesConstants from '@utils/rolesConstants';
import { useTranslation } from 'react-i18next';

interface DeactivationPayloadProps {
  action: LorawanActionTypes.DEACTIVATION;
  devices: {
    devEui: string;
  }[];
}

interface DeactivationProps {
  devices: DeviceLoraWanProps[];
  isUpload?: boolean;
}

const useDeactivation = ({
  devices,
  isUpload,
}: DeactivationProps): DeviceActionProps => {
  const { t } = useTranslation('device-actions');

  const payloadToSend = useMemo(
    (): DeactivationPayloadProps => ({
      action: LorawanActionTypes.DEACTIVATION,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            devEui: device.devEui,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    title: t(
      `device-actions:labels.lorawan.${rolesConstants.LORAWAN_DEACTIVATION}`,
    ),
    payloadToSend,
  };
};

export default useDeactivation;
